import React, { useState, useEffect, useRef } from "react";
import { apiRequest } from "util/services";

/**
 * @param {boolean} readOnly - list view: display only (edit via ChildTopicPopup)
 * @param {string|number} gap - left margin after topic name (e.g. 16)
 */
const TopicDescriptionField = ({
  topicId,
  language = "English",
  readOnly = false,
  gap = 16,
}) => {
  const [description, setDescription] = useState("");
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!topicId) {
      setLoaded(true);
      return;
    }
    setLoaded(false);
    const langParam = encodeURIComponent(language || "English");
    apiRequest(
      `library/topic_definitions/${topicId}?language=${langParam}`,
      "GET",
      null,
      true
    ).then((res) => {
      if (res?.success?.description) {
        setDescription(res.success.description);
      } else {
        setDescription("");
      }
      setLoaded(true);
    });
  }, [topicId, language]);

  const save = async () => {
    if (readOnly) return;
    setSaving(true);
    await apiRequest(
      `library/topic_definitions/${topicId}`,
      "PUT",
      { description, language },
      true
    );
    setSaving(false);
    setEditing(false);
  };

  if (!loaded) return null;

  const wrapStyle = {
    marginLeft: gap,
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "60%",
  };

  if (readOnly) {
    if (!description) return null;
    return (
      <div style={wrapStyle} onClick={(e) => e.stopPropagation()}>
        <span
          style={{
            fontSize: 12,
            color: "#aaa",
            display: "inline",
            lineHeight: 1.4,
          }}
        >
          {description}
        </span>
      </div>
    );
  }

  return (
    <div style={wrapStyle} onClick={(e) => e.stopPropagation()}>
      {editing ? (
        <textarea
          ref={textareaRef}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          onBlur={save}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              save();
            }
            if (e.key === "Escape") {
              setEditing(false);
            }
          }}
          autoFocus
          rows={3}
          style={{
            width: "100%",
            background: "transparent",
            border: "1px solid #6c47ff",
            borderRadius: 4,
            color: "#ccc",
            fontSize: 12,
            padding: "4px 8px",
            resize: "vertical",
            outline: "none",
          }}
        />
      ) : (
        <span
          onClick={() => setEditing(true)}
          style={{
            fontSize: 12,
            color: description ? "#aaa" : "#555",
            cursor: "text",
            fontStyle: description ? "normal" : "italic",
            display: "block",
            lineHeight: 1.4,
          }}
        >
          {saving ? "Saving..." : description || "Add a description..."}
        </span>
      )}
    </div>
  );
};

export default TopicDescriptionField;
